(function() {
  const WORKER_URL = 'https://paceline-rye-production.up.railway.app/api/flash-picks';
  const SIZING_KEY = 'ap_sizing'; // localStorage key set by app-portal.js

  function getSizing() {
    try { return JSON.parse(localStorage.getItem(SIZING_KEY) || '{}'); }
    catch { return {}; }
  }

  function buildUrl(sizing) {
    const p = new URLSearchParams();
    if (sizing.shoe)       p.set('shoe', sizing.shoe);
    if (sizing.shoe_width) p.set('shoe_width', sizing.shoe_width);
    if (sizing.top)        p.set('top', sizing.top);
    if (sizing.pant)       p.set('pant', sizing.pant);
    if (sizing.audience)   p.set('audience', sizing.audience.join ? sizing.audience.join(',') : sizing.audience);
    return `${WORKER_URL}?${p.toString()}`;
  }

  function fmt(n) {
    n = parseFloat(n);
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function renderCard(pick) {
    // When Pacepoints price is displayed, show the discount vs MSRP for that price,
    // not the sale→MSRP discount (they're different numbers, don't confuse users).
    const effectivePct = (pick.ppPrice && pick.origPrice && pick.origPrice > pick.ppPrice)
      ? Math.round(((pick.origPrice - pick.ppPrice) / pick.origPrice) * 100)
      : pick.discountPct;
    const discount = effectivePct ? `<div class="fp-badge">-${effectivePct}%</div>` : '';
    const fsaBadge = pick.fsa ? `<span class="fsa-badge">FSA/HSA</span>` : '';
    const hasOriginal = pick.origPrice && pick.origPrice > pick.salePrice;
    let priceHtml;
    if (pick.ppPrice && pick.ppCost) {
      const origStrike = hasOriginal
        ? `<span class="fp-orig">${fmt(pick.origPrice)}</span> `
        : `<span class="fp-orig">${fmt(pick.salePrice)}</span> `;
      priceHtml = `<div class="fp-price fp-price--pp">${origStrike}<span class="fp-pp-price">${fmt(pick.ppPrice)}</span><span class="fp-pp-pts">with ${Math.round(pick.ppCost).toLocaleString()} Pacepoints</span></div>`;
    } else if (hasOriginal) {
      priceHtml = `<div class="fp-price"><span class="fp-orig">${fmt(pick.origPrice)}</span><span class="fp-sale">${fmt(pick.salePrice)}</span></div>`;
    } else {
      priceHtml = `<div class="fp-price"><span class="fp-sale">${fmt(pick.salePrice)}</span></div>`;
    }
    return `<a href="${pick.url}" class="fp-card" rel="noopener"><div class="fp-img-wrap">${discount}${fsaBadge}<img src="${pick.image}" alt="${pick.title}" class="fp-img" loading="lazy"></div><div class="fp-body"><div class="fp-brand">${pick.brand}</div><div class="fp-name">${pick.title}</div>${priceHtml}${pick.size ? `<div class="fp-size">Size ${pick.size}</div>` : ''}</div></a>`;
  }

  function renderSkeleton(n) {
    n = n || 4;
    return Array(n).fill('<div class="fp-card fp-skeleton"><div class="fp-img-wrap fp-sk-img"></div><div class="fp-body"><div class="fp-sk-line fp-sk-short"></div><div class="fp-sk-line"></div><div class="fp-sk-line fp-sk-shorter"></div></div></div>').join('');
  }

  async function load(containerEl) {
    const sizing = getSizing();

    // Show skeletons immediately
    containerEl.innerHTML = renderSkeleton(4);

    try {
      const res = await fetch(buildUrl(sizing));
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const picks = await res.json();

      if (!picks.length) {
        containerEl.innerHTML = `<div class="fp-empty"><div class="fp-empty-icon">🏷️</div><div class="fp-empty-title">No sale items match your size right now</div><div class="fp-empty-sub">We check every 30 minutes. Save your sizing above so we know what to look for.</div></div>`;
        return;
      }

      containerEl.innerHTML = picks.map(renderCard).join('');
    } catch (err) {
      console.warn('[flash-picks] fetch failed:', err.message);
      containerEl.innerHTML = `<div class="fp-empty"><div class="fp-empty-sub">Couldn't load flash picks right now — try again in a moment.</div></div>`;
    }
  }

  window.apFlashPicks = { load: load };

  // Auto-init if container exists
  document.addEventListener('DOMContentLoaded', function() {
    var el = document.getElementById('apFlashPicksGrid');
    if (el) load(el);
  });
})();
